import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import bank from '../../assets/images/secure-image.jpg'

const Privacy = () => {
  return (
    <div>
      <SimpleHero
        title="Your privacy, protected"
        subtitle="We collect only what’s needed, protect it with modern security, and give you control over how it’s shared."
        primaryLabel="Contact privacy"
        primaryHref="/contact"
        variant="sofi"
        imageSrc={bank}
        imageAlt="Security"
        imageOn="right"
        tiltImage
        badges={["Data minimization","Security‑first","Your choices"]}
      />
      <FeatureList
        items={[
          { title: 'Data minimization', desc: 'Only the info required to provide services.' },
          { title: 'Security‑first', desc: 'Encryption, monitoring, and access controls.' },
          { title: 'Your choices', desc: 'Manage communications and sharing preferences.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/contact">Request full policy</a>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
